import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PanelComponent, PanelFooterComponent, PanelHeaderComponent } from '@rocksoft/cdk';
import { OsUpdate } from '@rocksoft/osupdates-sdk';
import { CategoryAllowedOsUpdate } from '../../types/location-allowed-os-update.types';
import { OsUpdateListComponent } from './os-update-list.component';

@Component({
  selector: 'era-os-update-select',
  templateUrl: './os-update-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PanelComponent, PanelHeaderComponent, OsUpdateListComponent, PanelFooterComponent, FaIconComponent],
})
export class OsUpdateSelectComponent {
  public readonly locationAllowedOsUpdates = input.required<CategoryAllowedOsUpdate[]>();
  public readonly availableOsUpdates = input.required<OsUpdate[]>();

  public readonly osupdateDeleted = output<OsUpdate>();
  public readonly osupdateAdded = output<OsUpdate>();
  public readonly saveChanges = output();

  private selection: OsUpdate;
  public isEditing = true;

  public select(osupdate: OsUpdate) {
    this.selection = osupdate;
  }

  public addSelected() {
    if (this.selection) {
      this.osupdateAdded.emit(this.selection);
    }
  }

  public edit() {
    this.isEditing = true;
  }

  public save() {
    this.isEditing = false;
    this.saveChanges.emit();
  }

  public deleted(osupdate: OsUpdate) {
    this.osupdateDeleted.emit(osupdate);
  }
}
